import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  content: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    marginBottom: theme.spacing(8),
    overflowWrap: 'anywhere',
    [theme.breakpoints.up('md')]: {
      marginLeft: 'auto',
      marginRight: 'auto',
      maxWidth: theme.breakpoints.width('md'),
    },
  },
  active: {
    fontWeight: 'bold',
  },
  performlogo: {
    margin: '10px',
    maxWidth: '350px',
    maxHeight: '120px',
  },
  logos: {
    display: 'flex',
    justifyContent: 'center',
    height: 100,
  },
  icon: {
    color: 'white',
    display: 'flex',
    alignItems: 'center',
  },
}));

export default useStyles;
